declare global {
  interface Window {
    config: {
      auth_ui?: {
        sha: string;
        branch: string;
      };
    };
  }
}

/**
 * Sets window.config.auth_ui app version properties
 */
export function setAppVersion() {
  // add versioning
  window.config = window.config || {};
  window.config.auth_ui = {
    sha: import.meta.env.VITE_SHORT_SHA,
    branch: import.meta.env.VITE_REF_NAME,
  };
}
